import React from 'react';
import { RecommendationFilters as FilterType } from '../../services/recommendations';

interface Props {
  filters: FilterType;
  onFiltersChange: (filters: FilterType) => void;
  onClear: () => void;
}

export const RecommendationFilters: React.FC<Props> = ({
  filters,
  onFiltersChange,
  onClear
}) => {
  const updateFilter = (key: keyof FilterType, value: string | boolean | undefined) => {
    onFiltersChange({
      ...filters,
      [key]: value === '' ? undefined : value
    });
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-medium">Filters</h3>
        <button
          onClick={onClear}
          className="text-sm text-blue-600 hover:text-blue-700"
        >
          Clear All
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Traveler Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Traveler Name
          </label>
          <input
            type="text"
            value={filters.traveler_name || ''}
            onChange={(e) => updateFilter('traveler_name', e.target.value)}
            placeholder="Search by name..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Consultation Number */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Consultation Number
          </label>
          <input
            type="text"
            value={filters.consultation_number || ''}
            onChange={(e) => updateFilter('consultation_number', e.target.value)}
            placeholder="VH-202501..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Review Level */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Review Level
          </label>
          <select
            value={filters.review_level || ''}
            onChange={(e) => updateFilter('review_level', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All Levels</option>
            <option value="HIGH">High Risk</option>
            <option value="MEDIUM">Medium Risk</option>
            <option value="LOW">Low Risk</option>
          </select>
        </div>

        {/* Date From */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date From
          </label>
          <input
            type="date"
            value={filters.date_from || ''}
            onChange={(e) => updateFilter('date_from', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Date To */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date To
          </label>
          <input
            type="date"
            value={filters.date_to || ''}
            onChange={(e) => updateFilter('date_to', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Validation Status */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Validation Status
          </label>
          <select
            value={filters.validation_passed === undefined ? '' : filters.validation_passed.toString()}
            onChange={(e) => updateFilter('validation_passed', 
              e.target.value === '' ? undefined : e.target.value === 'true'
            )}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">All</option>
            <option value="true">Validated</option>
            <option value="false">Not Validated</option>
          </select>
        </div>
      </div>
    </div>
  );
};